export const getRelevantCategories = (weightGoal, gainMuscle) => {
    const map = {
      "Weight Loss_yes": [
        "Fat Burning & Endurance",
        "Muscle Building & Strength Training",
        "Full-Body & Endurance Sports",
      ],
      "Weight Loss_not important": [
        "Fat Burning & Endurance",
        "Full-Body & Endurance Sports",
      ],
      "Weight Gain_yes": [
        "Muscle Building & Strength Training",
        "Flexibility & Relaxation",
        "Full-Body & Endurance Sports",
      ],
      "Weight Gain_not important": [
        "Flexibility & Relaxation",
        "Full-Body & Endurance Sports",
      ],
      "Weight Stabilization_yes": [
        "Muscle Building & Strength Training",
        "Flexibility & Relaxation",
        "Full-Body & Endurance Sports",
      ],
      "Weight Stabilization_not important": [
        "Muscle Building & Strength Training",
        "Flexibility & Relaxation",
      ],
    };

    const key = `${weightGoal}_${gainMuscle?.toLowerCase()}`;
    return map[key] || [];
  };